import React, { useId } from "react";

// The back of the deck's cards (draw pile, a card flying from it, the tutorial), drawn like the
// logo's cards: warm charcoal lacquer rimmed in gold (`.card-back` on the card itself, index.css), a
// hairline frame inside the rim, a fine gold trellis that fades towards the middle, and the
// logo's spade in a gold lozenge. Laid out like a real card back: a margin all round, the
// pattern over the whole face, the mark at the centre.
const SPADE =
  "M0-13C-3-5.5-12 0-12 6.5c0 4.3 3.3 7 6.5 7 2 0 3.7-.8 4.7-2-.2 2.6-1.2 4.7-3.2 6.5h8c-2-1.8-3-3.9-3.2-6.5 1 1.2 2.7 2 4.7 2 3.2 0 6.5-2.7 6.5-7C12 0 3-5.5 0-13Z";

export function CardBack() {
  // One gradient per card: an id shared by several cards breaks when the first one is hidden.
  const gold = `card-back-gold-${useId().replace(/[^\w-]/g, "")}`;
  return (
    <>
      <span className="card-back-frame" aria-hidden="true" />
      <span className="absolute inset-0 flex items-center justify-center" aria-hidden="true">
        <svg viewBox="-20 -27 40 54" className="w-[44%]">
          <defs>
            <linearGradient id={gold} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#fbe7a8" />
              <stop offset=".5" stopColor="#d8ab4f" />
              <stop offset="1" stopColor="#9a7224" />
            </linearGradient>
          </defs>
          <path d="M0-26L19 0L0 26L-19 0Z" fill="#1d1912" stroke={`url(#${gold})`} strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M0-21.5L15.5 0L0 21.5L-15.5 0Z" fill="none" stroke="#e3c47a" strokeOpacity=".6" strokeWidth=".6" />
          <path d={SPADE} transform="translate(0 -1.7) scale(.68)" fill={`url(#${gold})`} />
        </svg>
      </span>
      <span className="card-back-sheen" aria-hidden="true" />
    </>
  );
}
